import React from 'react'
import { InputNumber } from 'antd'

export default class InputNumberDiwa extends React.Component<any> {
  onConfirm = (e: any) => {
    setTimeout(() => e.stopPropagation(), 0)

    if (e?.target?.parentElement?.parentElement) {
      e?.target?.parentElement?.parentElement?.classList.remove('ant-input-number-focused')
    }

    if (this.props.onValueConfirm) {
      const numValue = parseInt(e.target.value)

      if (this.props.min >= 0 && numValue < this.props.min) {
        return this.props.onValueConfirm(this.props.min)
      }
      if (this.props.max && numValue > this.props.max) {
        return this.props.onValueConfirm(this.props.max)
      }
      // if confirm fails we reset the value to the current props
      this.props.onValueConfirm(this.props.storeAsString ? e.target.value : numValue)?.then(res => {
        if (!res) {
          e.target.value = this.props.value
        }
      })
    }
  }

  customFocus = (e: any) => {
    if (this.props.onFocus) this.props.onFocus()
    if (this.props.focusSelectAll === undefined || this.props.focusSelectAll) e?.target.select()
  }

  render() {
    let propsNumber = { ...this.props }
    delete propsNumber.focusSelectAll
    delete propsNumber.onFocus
    delete propsNumber.className
    delete propsNumber.onValueConfirm
    return (
      <InputNumber
        className={'diwa-input-number ' + this.props.className}
        onFocus={this.customFocus}
        {...propsNumber}
        onPressEnter={this.onConfirm}
        onBlur={this.onConfirm}
        type='number'
        onDragStart={e => {
          e.preventDefault()
        }}
        onDragEnd={e => {
          e.preventDefault()
        }}
      />
    )
  }
}
